import { Modal } from "react-bootstrap";

export default function ModalCampaignProjects({ show, projects, onClose }) {
  return (
    <Modal show={show} onHide={() => onClose()} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Project Campaign</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {projects.length === 0 && <p className="text-muted mb-0">Tidak ada project</p>}
        {projects.length > 0 && (
          <table className="table table-sm table-bordered table-hover mb-0">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Project</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project, index) => (
                <tr key={project.id || index}>
                  <td width={50}>{index + 1}</td>
                  <td>{project.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => onClose()}>
          Tutup
        </button>
      </Modal.Footer>
    </Modal>
  );
}
